
import { mapGetters } from 'vuex'
import PzTabs from '@/components/pz-tabs'
import List from './fast/list.vue'
import Active from './fast/active.vue'
import Section from './fast/section.vue'
import Search from './fast/search.vue'
import Sort from './fast/sort.vue'
import Quick from './fast/quick.vue'
import Server from './fast/server.vue'

import { FieldType } from './fast/enum.js'
import { getDefaultFilterValue, getFilterValue, getSelectDataByFilterOptions, removeFilterItem, resetFilter } from './fast/useFast'
import { getStoreByFilterOptions } from '@/store/filter'

function firstCharToUpperCase(str) {
	return str.replace(/^\S/, s => s.toUpperCase())
}
export default {
	components: {
        PzTabs,
        List,
        Active,
        Section,
        Search,
        Sort,
        Quick,
        Server
    },
	props: {
		gameId: {
			type: Number,
			requried: true
		},
        topTabs: {
            type: Array,
            default: () => []
        },
		defaultGoodsCatalogueId: {
			type: [Number, String],
			default: 6
		},
		filter: {
			type: Object,
			requried: true
		},
        goodsSearchActions: {
			type: Object,
			requried: true
		},
		sort: {
			requried: true
		},
		sortName: {
			requried: true
		},
		order: {
			type: String,
			requried: true
		},
		switchText: {
			type: Boolean,
			requried: true
		},
		searchWords: {
			type: String,
			requried: true
		},
		total: {
			type: Number,
			default: 0
		},
		gameConfig: {
			type: Array,
			default: () => []
		},
		filterSearchPropertyIds:{
			type: Object,
			requried: true
		},
        isGeneralGoods: {
            type: Boolean,
            default: false
        },
        serverTree: {
            type: Array,
            default: () => []
        },


        filterOriginData: {
            type: Array,
            default: () => []
        },
        latestExtraFilter: {
            type: Object,
            default: () => ({})
        }
	},
	computed: {
        ...mapGetters({
            getFastFilter: 'filter/getFastFilter',
            getFilterMap: 'filter/getFilterMap',
        }),
        history() {
            // return this.getFilterMap[this.gameId] || []
            return this.getFastFilter(this.gameId)
        },
		sectionOptions() {
            return this.filterOptions?.filter(category => category.fieldType === 'SECTION' || category.fieldType === 'PRICE')
        },
	},
    data() {
        return {
            localSelectOptions: [], // 本地数据
            // ... 其他 data
            activeTab: this.topTabs[0]?.name || '',
            goodsCatalogueId: this.defaultGoodsCatalogueId,


            filterOptions: [],

        }
    },

    watch: {
        topTabs: {
            handler(newVal) {
                this.activeTab = newVal[0]?.name || ''
            },
            immediate: true
        },
        filterOriginData: {
            handler(newVal) {
                if (newVal) {
                    this.getGoodsPropertyOptions()
                }
            },
            immediate: true
        },
    },

    methods: {
        onSearch(addHistory = true) {
            // 将筛选选项转换为搜索数据格式
            const selectData = getSelectDataByFilterOptions({
                filterOptions: this.filterOptions,
                gameId: this.gameId,
                goodsCatalogueId: this.goodsCatalogueId
            })

            // 添加历史记录
            if (addHistory) {
                this.$store.dispatch('filter/addFastFilter', { gameId: this.gameId, data: getStoreByFilterOptions(this.filterOptions) })
                Object.entries(this.latestExtraFilter).forEach(([key, value]) => {
                    // console.log(key, value, 'latestExtraFilter')
                    this.$store.dispatch('filter/updateLatestFilter', { gameId: this.gameId, key, data: value })
                })
            }
            this.$emit('update:filter', getFilterValue(this.filter, selectData, this.filterOptions))


            // 发射搜索事件
            this.$emit('search')
        },
        onReSearch(data, filterData) {
            this.$emit('reSearch', filterData)
            this.$store.dispatch('filter/updateLastIsEmpty', false)
            this.filterOptions = data
            this.$store.dispatch('filter/addFastFilter', {
                gameId: this.gameId,
                data: getStoreByFilterOptions(this.filterOptions)
            })
            this.onSearch(false)

        },
        onRefresh() {
            this.$emit('reSearch')
        },
        resetFilter() {
            this.filterOptions = resetFilter(this.filterOptions)

			const filter = {}
			// const searchWords = ''
			const sort = ''
			const sortName = ''
			const order = 'ASC'
            const latestExtraFilter = {}
			this.$emit('update:filter', filter)
			// this.$emit('update:searchWords', searchWords)
			this.$emit('update:sort', sort, false)
			this.$emit('update:sortName', sortName)
			this.$emit('update:order', order, false)
            this.$emit('update:latestExtraFilter', latestExtraFilter)

            // this.$store.dispatch('filter/updateLastIsEmpty', true)
            this.$store.dispatch('filter/addFastFilter', {
                gameId: this.gameId,
                data: []
            })

			this.$emit('search')
            // this.onRefresh()
        },
        removeFilterItem(item, actionList) {
            if (actionList.length === 1) {
                this.filterOptions = resetFilter(this.filterOptions)
                this.onSearch()
                return
            }
            this.filterOptions = removeFilterItem(item, this.filterOptions)
            // filterStore.refreshLatest(this.gameId, getStoreByFilterOptions(filterOptions))
            // this.onRefresh()
            this.onSearch()
        },
        getGoodsPropertyOptions() {
            let { filterOriginData, isGeneralGoods } = this
            const latestHistory = this.$store.getters['filter/getLatest'](this.gameId)
            if (filterOriginData.length) {
                // 过滤并初始化筛选选项
                const { SECTION, SINGLE_CASCADE, SINGLE, LABEL, CHECKBOX } = FieldType
                const filterOptions = filterOriginData
                    .filter((item) => {
                        // 区间筛选
                        const isSection = [SECTION].includes(item.fieldType || '')
                        // 级联、单选、标签、复选框 && 选项有数据
                        const isOptions = [SINGLE_CASCADE, SINGLE, LABEL, CHECKBOX].includes(item.fieldType || '') && item.options?.length
                        return isSection || isOptions
                    })
                    .map((opt) => {
                        const recoverData = (latestHistory)?.list?.find((item) => item.id === opt.id) || {}
                        const defaultValue = getDefaultFilterValue(opt)

                        // 深度克隆恢复数据以确保响应式
                        const mergedData = {
                            ...defaultValue,
                            ...JSON.parse(JSON.stringify(recoverData))
                        }

                        return mergedData
                    })

                // 使用Vue.set确保filterOptions的响应式
                this.$set(this, 'filterOptions', filterOptions)
                // 通用商品，则将mappingField拼接上fieldType，为请求列表接口时，处理参数格式做准备
                // 如：price => price_section、single1 => single1_single
                if (isGeneralGoods) {
                    this.filterOptions.forEach(item => {
                        if ([SECTION, SINGLE].includes(item.fieldType)) {
                            item.mappingField = `${item.mappingField}_${item.fieldType.toLowerCase()}`
                        }
                    })
                }
                // console.log(this.filterOptions, latestHistory)
                // const selectData = getSelectDataByFilterOptions({
                //     filterOptions: this.filterOptions,
                //     gameId: gameId,
                //     goodsCatalogueId: goodsCatalogueId
                // })
                // $emit('update:filter', getFilterValue(filter, selectData, filterOptions))
                // $emit('onFilterOptionsUpdate', filterOptions)
            } else {
                this.filterOptions = []
            }
        }
    }
}
